import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { Service } from "../../../models/service";
import {TranslatedBaseError} from "../../../components/pages/TranslatedBaseError";

@Component({
  selector: "release-notes-create",
  templateUrl: "./release-notes-create.component.html",
})
export class ReleaseNotesCreateComponent extends TranslatedBaseError implements OnInit {

  @Output() public closeEvent = new EventEmitter();
  @Output() public sendReleaseNote = new EventEmitter();
  @Input() public service: Service;

  public releaseNote: any = {
    title: null,
    description: null,
    typesOfPublication: [],
  };

  public ngOnInit() {
    console.log(this.service);
  }

  public formatNewVersion() {
    const current = this.service && this.service.version ? Number(this.service?.version.replace("v", "")) : 0;
    return  current + 1;
  }

  public close() {
    this.closeEvent.emit();
  }

  public save(direct: boolean = false) {
    if (!direct) {
      if (!this.releaseNote.title) {
        this.error("Please set a release note title", "Release note incomplete!");
        return;
      }
      if (!this.releaseNote.typesOfPublication.length) {
        this.error("Please set at least one tag", "Release note incomplete!");
        return;
      }
    }
    this.sendReleaseNote.emit(direct ? null : this.releaseNote);
    console.log("--- save RN", this.releaseNote);
  }

  public updateTypes(e) {
    this.releaseNote.typesOfPublication = e;
    console.log("--- types", e);
  }
}
